import React from "react";
import useCollapse from "react-collapsed";
import ChevronRightLargeIcon from "@atlaskit/icon/glyph/chevron-right-large";
import HipchatChevronDownIcon from "@atlaskit/icon/glyph/hipchat/chevron-down";
import Button from "@atlaskit/button";

import styles from "./Expandable.module.css";
export function Expandable({ description, id }) {
  const { getCollapseProps, getToggleProps, isExpanded } = useCollapse();

  return (
    <div>
      {description ? (
        <Button
          style={{
            backgroundColor: "#fff",
            lineHeight: "inherit",
            height: "inherit",
          }}
          {...getToggleProps()}
          iconBefore={
            isExpanded ? <HipchatChevronDownIcon /> : <ChevronRightLargeIcon />
          }
        >
          {isExpanded ? "Description" : description}
        </Button>
      ) : (
        // <div className={styles.hypen}>-</div>
        <>-</>
      )}
      <section {...getCollapseProps()}>
        {description ? <div className={styles.item}>{description}</div> : "-"}
      </section>
    </div>
  );
}
